import { roleAdmin, roleManager, roleSuperAdmin } from '@/mixins/roles';

const OrganisationToursSections = () => import('@/pages/organisation-tours/sections.vue');

export default [
  {
    path: '/organisation-tours/sections',
    name: 'OrganisationToursSections',
    meta: {
      auth: {
        roles: [roleAdmin, roleSuperAdmin, roleManager],
        forbiddenRedirect: '/forbidden',
      },
      title: [
        'Экскурсии мир',
        'Разделы',
      ],
    },
    component: OrganisationToursSections,
  },
  {
    path: '/organisation-tours/sections/:id',
    name: 'OrganisationToursSectionsForm',
    meta: {
      auth: {
        roles: [roleAdmin, roleSuperAdmin, roleManager],
        forbiddenRedirect: '/forbidden',
      },
      title: [
        'Экскурсии мир',
        'Разделы',
      ],
    },
    component: OrganisationToursSections,
  },
];
